import React from 'react';
const bonos = [{
  name: 'Clase Lista en 10 Min',
  desc: '12 plantillas por cantidad de alumnos',
  price: '$12.000'
}, {
  name: 'Plan B Lluvia',
  desc: '20 circuitos indoor listos para usar',
  price: '$9.000'
}, {
  name: 'Progreso Visible',
  desc: 'Fichas + reportes WhatsApp + tracker anual',
  price: '$10.000'
}, {
  name: 'Biblioteca de Consignas',
  desc: '120 frases listas por golpe y nivel',
  price: '$8.000'
}, {
  name: 'Pack de Calentamientos',
  desc: '52 entradas en calor por nivel',
  price: '$9.000'
}, {
  name: 'Checklist Clase Perfecta',
  desc: 'Control de calidad y timing en 3 min',
  price: '$8.000'
}];
export function BonusSection() {
  return <section className="w-full bg-black py-12 px-4" data-id="element-1">
      <div className="max-w-5xl mx-auto" data-id="element-2">
        <div className="text-center mb-8" data-id="element-3">
          <h2 className="text-3xl sm:text-4xl font-black text-white mb-2" data-id="element-4">
            + <span className="text-[#00B4D8]" data-id="element-5">6 Bonos Gratis</span>
          </h2>
          <p className="text-gray-400 text-sm" data-id="element-6">
            Incluidos en todas las ofertas
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 mb-8" data-id="element-7">
          {bonos.map((b, i) => <div key={i} className="bg-[#001a2d] border border-[#00B4D8]/40 rounded-xl p-4 flex flex-col" data-id="element-8">
              <div className="flex items-center gap-2 mb-2" data-id="element-9">
                <span className="text-[#00B4D8] text-xl font-black" data-id="element-10">
                  0{i + 1}
                </span>
                <h3 className="text-white font-bold text-sm" data-id="element-11">{b.name}</h3>
              </div>
              <p className="text-gray-400 text-xs flex-1 mb-3" data-id="element-12">{b.desc}</p>
              <div className="flex items-center gap-2" data-id="element-13">
                <span className="text-gray-500 line-through text-xs" data-id="element-14">
                  {b.price}
                </span>
                <span className="bg-[#00B4D8] text-black font-black text-xs px-2 py-0.5 rounded-full" data-id="element-15">
                  GRATIS
                </span>
              </div>
            </div>)}
        </div>

        <div className="border border-[#00B4D8]/30 rounded-xl p-4 text-center bg-[#000d1a] flex flex-wrap items-center justify-center gap-2" data-id="element-16">
          <span className="text-gray-400 line-through text-sm" data-id="element-17">$56.000</span>
          <span className="text-[#00B4D8] text-lg sm:text-xl font-black" data-id="element-18">
            🎁 GRATIS con cualquier plan
          </span>
        </div>
      </div>
    </section>;
}